
<template>
	<div class="container">
		<Transition name="fade">
			<PageLoaderComponent v-if="loading" />
			<div v-else>
				<div class="grid flex flex--wrap mb-24">
					<div class="grid__item a7-12 f6-6">
						<h1 class="h1">
							Add scope
						</h1>
					</div>
				</div>
				<div class="steps-nav steps-nav--scope">
					<div
						v-for="( step, index ) in steps"
						:key="'steps-nav-' + index"
						class="steps-nav__step"
						:class="( step.step_number <= active_step_number ) ? ' steps-nav__step--active' : null"
					>
						<p
							class="steps-nav__step-title"
							:class="( step.step_number < active_step_number ) ? ' steps-nav__step-title--completed' : null"
						>
							Step {{ step.step_number }}
						</p>
						<p>{{ step.title }}</p>
					</div>
				</div>
				<div class="grid flex flex--wrap mb-24">
					<div class="grid__item a7-12 d6-6">
						<div class="steps">
							<PandaDocComponent
								:step="steps[0]"
								:active-step-number="active_step_number"
							/>
							<ProjectScopeComponent
								:step="steps[1]"
								:active-step-number="active_step_number"
							/>
							<ReviewComponent
								:step="steps[2]"
								:active-step-number="active_step_number"
							/>
						</div>
					</div>
				</div>
			</div>
		</Transition>
	</div>
</template>

<script setup>
import PageLoaderComponent from '../components/PageLoaderComponent';
import PandaDocComponent from '../components/add-project-scope/PandaDocComponent';
import ProjectScopeComponent from '../components/add-project-scope/ProjectScopeComponent';
import ReviewComponent from '../components/add-project-scope/ReviewComponent';

import { USER_GROUP_CLIENT } from '../constants';

import { useDataStore } from '../stores/data';
import { useAddProjectScopeStore } from '../stores/add-project-scope.js';
import { useRouter, useRoute } from 'vue-router';
import { ref, onMounted, computed } from 'vue';
import { storeToRefs } from 'pinia';

const data_store = useDataStore();
const add_project_scope_store = useAddProjectScopeStore();
const { setBreadcrumbs } = data_store;
const { getProject } = add_project_scope_store;
const {
	project,
	form_fields,
	steps,
	active_step_number
} = storeToRefs( add_project_scope_store );
const router = useRouter();
const route = useRoute();

const { user_group } = storeToRefs( data_store );

const user_is_client = computed( () => {
	return user_group.value === USER_GROUP_CLIENT;
} );

const loading = ref( true );

// Mount
onMounted( async() => {
	loading.value = true;

	if ( user_is_client.value ) {
		router.push( { name: 'home' } );
		return;
	}
	if ( !route.params.project_id ) {
		router.push( { name: 'projects' } );
		return;
	}

	form_fields.value.project_id = route.params.project_id;
	await getProject();

	if ( !project.value ) {
		router.push( { name: 'home' } );
		return;
	}

	setBreadcrumbs( [
		{
			label: 'Projects',
			route: { name: 'projects' },
			icon: 'briefcase'
		},
		{
			label: project.value.title,
			route: { name: 'projects__project', params: { project_id: project.value.id } },
			icon: 'briefcase'
		},
		{
			label: 'Add scope'
		}
	] );

	loading.value = false;
} );
</script>
